import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';

@Component({
  selector: 'app-otp-login',
  templateUrl: './otp-login.component.html',
  styleUrls: ['./otp-login.component.scss'],
})
export class OtpLoginComponent {
  phoneNumber: string = '';
  whatsappConsent: boolean = true;
  otpSent: boolean = false;
  otp!: number;
  noAccountFound: boolean = false;
  @Input() title = 'Login';
  @Input() minimal = false;

  @Input() reSendOtp = false;
  @Output() OtpSentSuccess = new EventEmitter<string>();

  constructor(
    private _route: Router,
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private globalUtilityService: GlobalUtilityService,
    private _sharedService: SharedService
  ) {}

  onSubmit() {
    this.globalUtilityService.showLoader();
    if (this.isValidPhoneNumber()) {
      const number = this.phoneNumber.replace(/-/g, '');
      this._authService.sendOtp(number).subscribe({
        next: (res: APIResponse) => {
          this.globalUtilityService.hideLoader();
          if (res.success) {
            this.otpSent = true;
            this.OtpSentSuccess.emit(number);
          } else {
            this.noAccountFound = true;
            this.globalUtilityService.showToast('error', res.message);
          }
        },
        error: (error: any) => {
          this.globalUtilityService.hideLoader();
          this.globalUtilityService.showToast('error', error.message);
        },
      });
    } else {
      this.globalUtilityService.hideLoader();
    }
  }

  isValidPhoneNumber(): boolean {
    const phonePattern = /^[0-9]{5}-[0-9]{5}$/;
    return phonePattern.test(this.phoneNumber);
  }

  formatPhoneNumber() {
    // Remove any non-digit characters first
    let digits = this.phoneNumber.replace(/\D/g, '');

    // Limit to 10 digits
    if (digits.length > 10) {
      digits = digits.substring(0, 10);
    }

    // Format with hyphen after first 5 digits
    if (digits.length > 5) {
      this.phoneNumber = `${digits.substring(0, 5)}-${digits.substring(5)}`;
    } else {
      this.phoneNumber = digits;
    }
  }
}
